import React from 'react';
import { ForgotPasswordForm } from '@features/auth/components/forgot-password/ForgotPasswordForm';

const ForgotPasswordPage: React.FC = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;
